import React from 'react';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

const Filtros = ({
    filtros,
    setFiltros,
    operadores,
    opcionesClientes,
    clienteFiltro,
    setClienteFiltro,
    opcionesTipoUnidad,
    tipoUnidadFiltro,
    setTipoUnidadFiltro,
    buscar,
    limpiar,
    loading,
    datosFiltrados,
    columnasExcel,
    exportarAExcel,
}) => {
    return (
        <div className="ev-filtros">
            <div className="grupo-filtro">
                <label>Inicio</label>
                <Calendar
                    value={filtros.desde}
                    onChange={(e) => setFiltros({ ...filtros, desde: e.value })}
                    dateFormat="dd/mm/yy"
                    showIcon
                    className="w-full"
                />
            </div>
            <div className="grupo-filtro">
                <label>Fin</label>
                <Calendar
                    value={filtros.hasta}
                    onChange={(e) => setFiltros({ ...filtros, hasta: e.value })}
                    dateFormat="dd/mm/yy"
                    showIcon
                    className="w-full"
                />
            </div>
            <div className="grupo-filtro">
                <label>Operador</label>
                <Dropdown
                    value={filtros.operador}
                    onChange={(e) => setFiltros({ ...filtros, operador: e.value })}
                    options={operadores}
                    optionLabel="name"
                    placeholder="Todos"
                    className="w-full"
                    filter
                    showClear
                />
            </div>
            <div className="grupo-filtro">
                <label>Tipo de Unidad</label>
                <Dropdown
                    value={tipoUnidadFiltro}
                    onChange={(e) => setTipoUnidadFiltro(e.value)}
                    options={opcionesTipoUnidad}
                    placeholder="Todos"
                    className="w-full"
                    showClear
                    emptyMessage="Sin datos cargados"
                />
            </div>
            <div className="grupo-filtro">
                <label>Cliente</label>
                <Dropdown
                    value={clienteFiltro}
                    onChange={(e) => setClienteFiltro(e.value)}
                    options={opcionesClientes}
                    placeholder="Todos"
                    className="w-full"
                    filter
                    showClear
                    emptyMessage="Sin datos cargados"
                />
            </div>
            <div className="grupo-filtro ev-botones">
                <Button icon="pi pi-search" label="Buscar" onClick={buscar} loading={loading} />
                <Button icon="pi pi-times" label="Limpiar" severity="secondary" onClick={limpiar} />
                <Button
                    icon="pi pi-file-excel"
                    label="Excel"
                    severity="success"
                    onClick={() => exportarAExcel(datosFiltrados, columnasExcel, 'EXCESOS_VELOCIDAD')}
                    disabled={datosFiltrados.length === 0}
                />
            </div>
        </div>
    );
};

export default Filtros;
